import React, { useState, useContext } from 'react';
import { Drama, RotateCcw } from 'lucide-react';
import PageHeader from '../ui/page-header';
import { AppContext } from '../../context/AppContext';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import SceneCard from './SceneCard';
import SceneDetailsSheet from './SceneDetailsSheet';
import SceneEditor from './SceneEditor';
import LoadingSpinner from '../common/LoadingSpinner';

const SceneControl = () => {
  const { scenes, devices, refreshScenes, isLoading } = useContext(AppContext);
  const [showEditor, setShowEditor] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [currentScene, setCurrentScene] = useState(null);
  
  const handleAddScene = () => {
    setCurrentScene(null);
    setShowEditor(true);
  };
  
  const handleEditScene = (scene) => {
    setCurrentScene(scene);
    setShowEditor(true);
    setShowDetails(false);
  };

  const handleViewDetails = (scene) => {
    setCurrentScene(scene);
    setShowDetails(true);
  };

  const handleSaveScene = (scene) => {
  };

  const handleCloseEditor = () => {
    setShowEditor(false);
    setCurrentScene(null);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
    setCurrentScene(null);
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <LoadingSpinner size="large" text="Loading scenes..." />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (showEditor) {
    return (
      <SceneEditor
        scene={currentScene}
        onClose={handleCloseEditor}
        onSave={handleSaveScene}
      />
    );
  }
  return (
    <>
      <PageHeader
        title="Scenes"
        subtitle="Control multiple devices at once"
        onAdd={handleAddScene}
        menuItems={[
          { label: 'Refresh', icon: RotateCcw, onClick: refreshScenes }
        ]}
      />

      <div className="px-4 py-6">

        {scenes.length === 0 ? (
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12 px-4">
              <Drama className="w-12 h-12 text-muted-foreground mb-4" />
              <h3 className="text-lg font-semibold mb-2">No Scenes Found</h3>
              <p className="text-muted-foreground text-center mb-6">
                No scenes are currently available in your system.
              </p>
              <Button onClick={handleAddScene}>
                Create Your First Scene
              </Button>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {scenes.map(scene => (
              <SceneCard
                key={scene.id}
                scene={scene}
                devices={devices}
                onEdit={handleEditScene}
                onDetails={handleViewDetails}
              />
            ))}
          </div>
        )}
      </div>

      {currentScene && (
        <SceneDetailsSheet
          scene={currentScene}
          devices={devices}
          open={showDetails}
          onClose={handleCloseDetails}
          onEdit={handleEditScene}
        />
      )}
    </>
  );
};

export default SceneControl;